import ScalarCopy_vue_vue_type_script_setup_true_lang_default from "./ScalarCopy.vue.script.js";
//#region src/components/ScalarCopy/ScalarCopy.vue
var ScalarCopy_default = ScalarCopy_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCopy_default as default };

//# sourceMappingURL=ScalarCopy.vue.js.map